import Vue from "vue";
import titleMixin from "./titleMixin";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from "axios";
import VueAxios from "vue-axios";
import "@/plugins/vue-toast-notification";
import HighchartsVue from "highcharts-vue";
import VModal from "vue-js-modal";
import loadScript from "vue-plugin-load-script";
import { GridPlugin } from "@syncfusion/ej2-vue-grids";
import Notifications from "vue-notification";
import Mono from "vue-mono";
// import Vuelidate from "vuelidate";

// Globalization
import VueI18n from "vue-i18n";
import { ENGLISH_TRANSLATIONS } from "./translations/en";
import { FRENCH_TRANSLATIONS } from "./translations/fr";
import { dateTimeFormats } from "./dateTimeFormats/dateTimeFormats";
import { numberFormats } from "./numberFormats/numberFormats";

// High Charts
import VueHighcharts from "vue-highcharts";
import Highcharts from "highcharts";
import loadSolidGauge from "highcharts/modules/solid-gauge";
import highchartsMore from "highcharts/highcharts-more";
import moment from "moment-timezone";
import configObject from "@/config";

// Vue CTK DATE TIME PICKER
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import VueApexCharts from "vue-apexcharts";
import VueSelect from "vue-select";

import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Flutterwave from "vue-flutterwave";

Vue.use(Flutterwave, {
  publicKey: "FLWPUBK-36fbfdc445fddc136025acc3d39a1ac3-X",
});

import "vue-select/dist/vue-select.css";

Vue.component("calendar", Calendar);
Vue.component("date-picker", DatePicker);
Vue.component("v-select", VueSelect);
// PK: test_pk_cbcfP6KmZ3z3yqfbWzEc
// SK: test_sk_cohZgkRdmQaAnFiJcx7V
//process.env.MONO_API_KEY
//live_pk_wNoKtOYej5c2SZLXlL0H
Vue.use(Mono, { publicKey: process.env.VUE_APP_MONO_API_KEY });
// Vue.use(Vuelidate);

moment.tz.setDefault("Africa/Lagos");

Vue.mixin(titleMixin);

highchartsMore(Highcharts);

loadSolidGauge(Highcharts);

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.component("donutChart", {
  template: "#donutTemplate",
  props: ["initialValues"],
  data() {
    return {
      chartData: [],
      colors: ["#6495ED", "goldenrod", "#cd5c5c", "thistle", "lightgray"],
      cx: 80,
      cy: 80,
      radius: 60,
      sortedValues: [],
      strokeWidth: 30,
    };
  },
});

Vue.use(VueHighcharts, { Highcharts });
Vue.use(GridPlugin);
Vue.use(VueApexCharts);
Vue.use(Notifications);

Vue.component("apexchart", VueApexCharts);

Vue.prototype.$moment = moment;
Vue.prototype.$eventHub = new Vue();
Vue.use(VModal);
Vue.use(HighchartsVue);

Vue.use(loadScript);

Vue.use(VueAxios, axios);

Vue.use(BootstrapVue);

// Globalization
Vue.use(VueI18n);

Vue.config.productionTip = false;

// axios.interceptors.response.use(response => {
//     return Promise.resolve(response);
// }, err => {
//     if (err.response.status === 403) {
//         router.push({ path: '/forbidden'})
//     } else {
//         return Promise.reject(err);
//     }
// })

// Globalization
const TRANSLATIONS = {
  "en-NG": ENGLISH_TRANSLATIONS,
  "fr-FR": FRENCH_TRANSLATIONS,
  "fr-NG": FRENCH_TRANSLATIONS,
  "en-FR": ENGLISH_TRANSLATIONS,
  "en-KE": ENGLISH_TRANSLATIONS,
  "fr-KE": FRENCH_TRANSLATIONS,
};

const i18n = new VueI18n({
  locale: "en-NG",
  messages: TRANSLATIONS,
  dateTimeFormats,
  numberFormats,
});

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
  components: { App },
}).$mount("#app");
